import React, { useMemo, useState } from "react";

// 1. Create Context
const AuthContext = React.createContext(null);

// 2. Create custom hook
export const useAuthContext = () => {
    const context = React.useContext(AuthContext);

    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
};

// 3. Create Provider
export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    
    const login = (username, password) =>{
        setUser(username);
        localStorage.setItem('token', username)
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('token');
    }

    const value = useMemo(() => {
        return {user: user, login, logout}
    }, [user]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}